export const STORAGE_KEY = 'need-ui';
